import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FinderTransitionInDirective } from './transition-in.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        FinderTransitionInDirective
    ],
    providers: [],
    exports: [
        FinderTransitionInDirective
    ]
})
export class FinderTransitionInModule {}
